import React, { useContext, useEffect, useRef, useState } from "react";

import { Form, Formik } from "formik";
import { toast } from "react-toastify";


import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useTheme } from "@material-ui/core/styles";
import { useStyles } from "./campaignModalStyles";
import useCampaignModal from "./useCampaignModal";
import { validateCampaignForm } from "./utils/validateCampaignForm";

import moment from "moment-timezone";
import { i18n } from "../../translate/i18n";

import {
  Box,
  Grid,
  Typography,
  FormControlLabel,
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { getCampaignTimezoneSync } from "../../helpers/getCampaignTimezone";
import { calculateEstimatedTime } from "../../utils/campaignCalculations";
import CampaignAlertModals from "./components/CampaignAlertModals";
import RecurrenceTabContent from "./components/tabs/RecurrenceTabContent";
import IntervalTabContent from "./components/tabs/IntervalTabContent";
import MessageTabContent from "./components/tabs/MessageTabContent";
import TaggingTabContent from "./components/tabs/TaggingTabContent";
import ResponderTabContent from "./components/tabs/ResponderTabContent";
import useCampaignAttachment from "./hooks/useCampaignAttachment";
import CampaignFormHeader from "./components/CampaignFormHeader";
import useCampaignData from "./hooks/useCampaignData";




const CampaignModal = ({
  open,
  onClose,
  campaignId,
  initialValues,
  onSave,
  resetPagination,
  campaignType = 'UNICA', // 'UNICA' o 'RECURRENTE'
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const {
    attachment,
    attachmentFile,
    attachmentInfo,
    campaign,
    campaignAiChoice,
    campaignEditable,
    cancelCampaign,
    companyId,
    companyTimezone,
    configTab,
    confirmationOpen,
    contactLists,
    currentCampaignType,
    datePastMessage,
    datePastModalOpen,
    deleteMedia,
    errorMessage,
    errorModalOpen,
    file,
    formKey,
    formatInvalidMessage,
    formatInvalidModalOpen,
    handleAttachFile,
    handleAttachmentFile,
    handleClose,
    handleContactListChange,
    handleFileListChange,
    handleSaveCampaign,
    handleTagListChange,
    isAttachmentSelected,
    isFileListSelected,
    isMounted,
    lastWrittenNameRef,
    messageTab,
    onResetAttachmentRef,
    pendingSaveValues,
    pendingScheduledAt,
    pendingSetFieldValue,
    promptsList,
    resetCampaign,
    responderConfigTab,
    restartCampaign,
    saveCampaignRef,
    scheduleFormSyncRef,
    selectedContactListCount,
    setAttachment,
    setAttachmentInfo,
    setCampaign,
    setCampaignAiChoice,
    setCampaignEditable,
    setConfigTab,
    setConfirmationOpen,
    setDatePastMessage,
    setDatePastModalOpen,
    setErrorMessage,
    setErrorModalOpen,
    setFormKey,
    setFormatInvalidModalOpen,
    setIsAttachmentSelected,
    setIsFileListSelected,
    setMessageTab,
    setPendingSaveValues,
    setPendingScheduledAt,
    setPendingSetFieldValue,
    setPromptsList,
    setSelectedContactListCount,
    setShortTimeMessage,
    setShortTimeModalOpen,
    setSizeExceededModalOpen,
    setWizardLocalChoice,
    shortTimeMessage,
    shortTimeModalOpen,
    sizeExceededMessage,
    sizeExceededModalOpen,
    tagLists,
    user,
    whatsapps,
    wizardLocalChoice,
  } = useCampaignModal({ open, onClose, campaignId, initialValues, onSave, resetPagination, campaignType });

  return (
    <div className={classes.root}>
      <ConfirmationModal
        title={i18n.t("campaigns.confirmationModal.deleteTitle")}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={deleteMedia}
      >
        {i18n.t("campaigns.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <CampaignAlertModals
        errorModalOpen={errorModalOpen}
        setErrorModalOpen={setErrorModalOpen}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        datePastModalOpen={datePastModalOpen}
        setDatePastModalOpen={setDatePastModalOpen}
        datePastMessage={datePastMessage}
        pendingSetFieldValue={pendingSetFieldValue}
        setPendingSetFieldValue={setPendingSetFieldValue}
        pendingSaveValues={pendingSaveValues}
        setPendingSaveValues={setPendingSaveValues}
        saveCampaignRef={saveCampaignRef}
        formatInvalidModalOpen={formatInvalidModalOpen}
        setFormatInvalidModalOpen={setFormatInvalidModalOpen}
        formatInvalidMessage={formatInvalidMessage}
        sizeExceededModalOpen={sizeExceededModalOpen}
        setSizeExceededModalOpen={setSizeExceededModalOpen}
        sizeExceededMessage={sizeExceededMessage}
        shortTimeModalOpen={shortTimeModalOpen}
        setShortTimeModalOpen={setShortTimeModalOpen}
        shortTimeMessage={shortTimeMessage}
        setShortTimeMessage={setShortTimeMessage}
        pendingScheduledAt={pendingScheduledAt}
        setPendingScheduledAt={setPendingScheduledAt}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle
          id="form-dialog-title"
          style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 8 }}
        >
          {campaignAiChoice === "yes" ? (
            <span role="img" aria-label={i18n.t("campaigns.dialog.ai.ariaAiEnvironment")} style={{ fontSize: "1.25rem" }}>
              ✨
            </span>
          ) : null}
          <span style={{ flex: "1 1 auto" }}>
            {campaignEditable ? (
              <>
                {campaignId
                  ? `${i18n.t("campaigns.dialog.update")}`
                  : currentCampaignType === 'RECURRENTE'
                    ? `NUEVA CAMPAÑA - RECURRENTE`
                    : `NUEVA CAMPAÑA - ÚNICA`}
              </>
            ) : (
              <>{`${i18n.t("campaigns.dialog.readonly")} - ${currentCampaignType === 'RECURRENTE' ? 'RECURRENTE' : 'ÚNICA'}`}</>
            )}
          </span>
        </DialogTitle>
        <div style={{ display: "none" }}>
          <input
            type="file"
            ref={attachmentFile}
            onChange={(e) => handleAttachmentFile(e)}
          />
        </div>
        <Formik
          key={formKey} // ✅ CRÍTICO: Key para forzar reinicialización completa cuando se resetea el formulario
          initialValues={campaign}
          // false: si true, cada setCampaign (p. ej. solo `name`) reinicializa Formik y borra campos no persistidos en `campaign` (IA, etiqueta, listas)
          enableReinitialize={false}
          validate={(values) => validateCampaignForm(values, { campaignAiChoice, campaignType })}
          onSubmit={async (values, actions) => {
            // ✅ CORRECCIÓN: Marcar todos los campos con errores como "touched" para mostrar errores visualmente
            const validationErrors = validateCampaignForm(values, { campaignAiChoice, campaignType });
            if (Object.keys(validationErrors).length > 0) {
              // ✅ CORRECCIÓN: Establecer errores y marcar campos como touched
              // Esto asegura que Formik reconozca los errores y los muestre visualmente
              actions.setErrors(validationErrors);
              
              // ✅ CORRECCIÓN: Crear un objeto completo de touched para todos los campos con errores
              const touchedFields = {};
              Object.keys(validationErrors).forEach(fieldName => {
                touchedFields[fieldName] = true;
              });
              // Marcar todos los campos con errores como touched de una vez
              actions.setTouched(touchedFields);
              
              // ✅ CORRECCIÓN: Cambiar a la pestaña que contiene el primer campo con error
              // Si el error es en RECURRENCIA, ir a esa pestaña
              if (validationErrors.recurrenceType || validationErrors.recurrenceInterval) {
                setConfigTab(0); // Pestaña RECURRENCIA
              } else if (validationErrors.message1 || validationErrors.message2 || validationErrors.message3 || validationErrors.message4 || validationErrors.message5) {
                setConfigTab(currentCampaignType === 'RECURRENTE' ? 1 : 0); // Pestaña MENSAJE
              } else if (validationErrors.promptId && campaignAiChoice === "yes") {
                setConfigTab(currentCampaignType === 'RECURRENTE' ? 1 : 0);
              } else if (validationErrors.replyPromptId && campaignAiChoice === "yes") {
                const rTab = currentCampaignType === 'RECURRENTE' ? 4 : 3;
                setConfigTab(rTab);
              } else if (validationErrors.autoTagEnabled || validationErrors.autoTagId) {
                setConfigTab(currentCampaignType === 'RECURRENTE' ? 3 : 2);
              }
              
              // No continuar con el submit si hay errores
              actions.setSubmitting(false);
              return;
            }
            
            try {
              await handleSaveCampaign(values, false, false, actions.setFieldValue);
            } catch (error) {
              // El error ya se maneja dentro de handleSaveCampaign
              console.error('[CampaignModal] Error en onSubmit:', error);
            } finally {
              // ✅ Asegurar que el formulario se desbloquee siempre, incluso si hay errores
              // ✅ CRÍTICO: Verificar que el componente esté montado antes de actualizar estado
              if (isMounted.current) {
              actions.setSubmitting(false);
              }
            }
          }}
        >
          {({ values, errors, touched, isSubmitting, setFieldValue, resetForm }) => {
            scheduleFormSyncRef.current = setFieldValue;
            // ✅ DEBUG: Loggear cuando el nombre cambia (sin usar hooks, solo en render)
            // Nota: Este log se ejecutará en cada render, pero es útil para debugging
            // En producción, se puede comentar o remover
            // ✅ FASE 4: Calcular tiempo estimado directamente desde los valores actuales
            const currentCalculatedTime = selectedContactListCount && selectedContactListCount > 0
              ? calculateEstimatedTime(
                  selectedContactListCount,
                  values.messageInterval || 45,
                  values.longerIntervalAfter || 20,
                  values.greaterInterval || 60
                )
              : null;
            
            const showAiWizardGate = !campaignId && campaignAiChoice === undefined;

            return (
              <Form>
              <DialogContent dividers className={classes.dialogContent}>
                {showAiWizardGate ? (
                  <Box py={2} px={0}>
                    <Typography variant="subtitle1" gutterBottom component="div" style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                      <span role="img" aria-hidden style={{ fontSize: "1.25rem", lineHeight: 1.2 }}>
                        ✨
                      </span>
                      <span>{i18n.t("campaigns.dialog.ai.wizardQuestion")}</span>
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16, display: "flex", gap: 8, alignItems: "flex-start" }}>
                      <span role="img" aria-hidden style={{ fontSize: "1.1rem", lineHeight: 1.4 }}>
                        🤖
                      </span>
                      <span>{i18n.t("campaigns.dialog.ai.wizardHelp")}</span>
                    </Typography>
                    <RadioGroup value={wizardLocalChoice} onChange={(e) => setWizardLocalChoice(e.target.value)}>
                      <FormControlLabel value="no" control={<Radio color="primary" />} label={i18n.t("campaigns.dialog.ai.choiceNo")} />
                      <FormControlLabel value="yes" control={<Radio color="primary" />} label={i18n.t("campaigns.dialog.ai.choiceYes")} />
                    </RadioGroup>
                    <Box mt={2} display="flex" justifyContent="flex-end">
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={!wizardLocalChoice}
                        onClick={() => {
                          const sel = wizardLocalChoice;
                          setCampaignAiChoice(sel);
                          setWizardLocalChoice("");
                          if (sel === "yes") {
                            setFieldValue("autoTagEnabled", true);
                            setFieldValue("confirmation", false);
                            setFieldValue("promptId", "");
                            setFieldValue("replyPromptId", "");
                            setMessageTab(0);
                          } else {
                            setFieldValue("promptId", "");
                            setFieldValue("replyPromptId", "");
                          }
                        }}
                      >
                        {i18n.t("campaigns.dialog.ai.continue")}
                      </Button>
                    </Box>
                  </Box>
                ) : (
                <Grid spacing={2} container>
                  <CampaignFormHeader
                    values={values}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    promptsList={promptsList}
                    contactLists={contactLists}
                    whatsapps={whatsapps}
                    tagLists={tagLists}
                    fileLists={file}
                    selectedContactListCount={selectedContactListCount}
                    campaignId={campaignId}
                    campaignEditable={campaignEditable}
                    campaignAiChoice={campaignAiChoice}
                    companyTimezone={companyTimezone}
                    currentCampaignType={currentCampaignType}
                    isAttachmentSelected={isAttachmentSelected}
                    configTab={configTab}
                    setConfigTab={setConfigTab}
                    lastWrittenNameRef={lastWrittenNameRef}
                    setCampaign={setCampaign}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    setErrorModalOpen={setErrorModalOpen}
                    setCampaignAiChoice={setCampaignAiChoice}
                    setMessageTab={setMessageTab}
                    setDatePastMessage={setDatePastMessage}
                    setPendingSetFieldValue={setPendingSetFieldValue}
                    setDatePastModalOpen={setDatePastModalOpen}
                    setShortTimeMessage={setShortTimeMessage}
                    setPendingScheduledAt={setPendingScheduledAt}
                    setShortTimeModalOpen={setShortTimeModalOpen}
                    handleContactListChange={handleContactListChange}
                    handleTagListChange={handleTagListChange}
                    handleFileListChange={handleFileListChange}
                  />
                  {/* ✅ FASE 4: CONTENIDO DE TABS - RECURRENCIA (solo para RECURRENTE) */}
                  {currentCampaignType === 'RECURRENTE' && configTab === 0 && (
                    <RecurrenceTabContent
                      values={values}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      campaignEditable={campaignEditable}
                    />
                  )}
                  
                  {/* ✅ FASE 4: CONTENIDO DE TABS - MENSAJE */}
                  {((currentCampaignType === 'UNICA' && configTab === 0) || (currentCampaignType === 'RECURRENTE' && configTab === 1)) && (
                    <MessageTabContent
                      values={values}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      isSubmitting={isSubmitting}
                      campaignEditable={campaignEditable}
                      campaign={campaign}
                      attachment={attachment}
                      attachmentInfo={attachmentInfo}
                      isFileListSelected={isFileListSelected}
                      attachmentFile={attachmentFile}
                      handleAttachFile={handleAttachFile}
                      setConfirmationOpen={setConfirmationOpen}
                      messageTab={messageTab}
                      setMessageTab={setMessageTab}
                      campaignAiChoice={campaignAiChoice}
                    />
                  )}

                  {/* ✅ FASE 4: CONTENIDO DE TABS - INTERVALO */}
                  {((currentCampaignType === 'UNICA' && configTab === 1) || (currentCampaignType === 'RECURRENTE' && configTab === 2)) && (
                    <IntervalTabContent
                      values={values}
                      setFieldValue={setFieldValue}
                      campaignEditable={campaignEditable}
                      campaign={campaign}
                      selectedContactListCount={selectedContactListCount}
                      contactLists={contactLists}
                      currentCalculatedTime={currentCalculatedTime}
                      campaignAiChoice={campaignAiChoice}
                    />
                  )}
                  
                  {/* ✅ FASE 4: CONTENIDO DE TABS - ETIQUETADO - Etiquetado Automático */}
                  {((currentCampaignType === 'UNICA' && configTab === 2) || (currentCampaignType === 'RECURRENTE' && configTab === 3)) && (
                    <TaggingTabContent
                      values={values}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      campaignEditable={campaignEditable}
                      campaignAiChoice={campaignAiChoice}
                      tagLists={tagLists}
                    />
                  )}

                  {campaignAiChoice === "yes" && configTab === responderConfigTab && (
                    <ResponderTabContent
                      values={values}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      campaignEditable={campaignEditable}
                      promptsList={promptsList}
                    />
                  )}

                </Grid>
                )}
              </DialogContent>
              <DialogActions className={classes.dialogActions} style={{ justifyContent: 'flex-end', padding: '16px 24px', gap: 8 }}>
                {campaign.status === "CANCELADA" && (
                  <Button
                    color="primary"
                    onClick={() => restartCampaign()}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.restart")}
                  </Button>
                )}
                {campaign.status === "EM_ANDAMENTO" && (
                  <Button
                    color="primary"
                    onClick={() => cancelCampaign()}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.cancel")}
                  </Button>
                )}
                {/* ✅ Botón CERRAR - siempre visible en TODAS las pestañas */}
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting}
                  variant="outlined"
                  style={{ borderColor: '#d32f2f', color: '#d32f2f' }}
                >
                  {i18n.t("campaigns.dialog.buttons.close")}
                </Button>
                {/* ✅ Botón ENVIAR CAMPAÑA / AGREGAR / EDITAR - siempre visible en TODAS las pestañas */}
                {(campaignEditable || campaign.status === "CANCELADA") && (
                  <Button
                    type="submit"
                    color="primary"
                    disabled={Boolean(isSubmitting || (!campaignId && campaignAiChoice === undefined))}
                    variant="contained"
                    className={classes.btnWrapper}
                  >
                    {campaignId
                      ? `${i18n.t("campaigns.dialog.buttons.edit")}`
                      : "ENVIAR CAMPAÑA"}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                )}
              </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
    </div>
  );
};

export default CampaignModal;
